import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import addPlus from '@/utilities/addPlus';
import ordinal from 'ordinal';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
let CharacterSheetModifier = class CharacterSheetModifier extends Vue {
    get valueToShow() {
        if (this.addPlus)
            return addPlus(this.value);
        else if (this.ordinal)
            return ordinal(this.value);
        else
            return this.value.toString();
    }
};
__decorate([
    Prop(Number)
], CharacterSheetModifier.prototype, "value", void 0);
__decorate([
    Prop(String)
], CharacterSheetModifier.prototype, "label", void 0);
__decorate([
    Prop(String)
], CharacterSheetModifier.prototype, "title", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetModifier.prototype, "addPlus", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetModifier.prototype, "ordinal", void 0);
__decorate([
    Prop(String)
], CharacterSheetModifier.prototype, "tweakPath", void 0);
__decorate([
    Prop(Object)
], CharacterSheetModifier.prototype, "tweaks", void 0);
CharacterSheetModifier = __decorate([
    Component({
        components: {
            CharacterSheetTweaker
        }
    })
], CharacterSheetModifier);
export default CharacterSheetModifier;
